import { useState } from "react";
import { Avatar, cx } from "@amber/ui";

export function CandidatePortrait({
  name,
  url,
  size = "md",
}: {
  name: string;
  url: string | null;
  size?: "md" | "lg";
}) {
  const [failed, setFailed] = useState(false);
  if (url && !failed)
    return (
      <img
        src={url}
        alt=""
        onError={() => {
          setFailed(true);
        }}
        className={cx("flex-none rounded-full bg-surface-3 object-cover", size === "lg" ? "size-14" : "size-9")}
      />
    );
  return <Avatar name={name} size={size === "lg" ? "lg" : "md"} />;
}
